import React, { useState } from "react";
import { PLACEHOLDER_IMAGES } from "../../utils/placeholderImage";

const ImageWithFallback = ({
  src,
  fallbackSrc = PLACEHOLDER_IMAGES.medium,
  alt = "",
  className = "",
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      setImgSrc(fallbackSrc);
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
      {...props}
    />
  );
};

export default ImageWithFallback;
